// Front-end only — no back-end counterpart.

export type ReviewSource = 'native' | 'google'

export const ReviewSource = {
  NATIVE: 'native',
  GOOGLE: 'google'
} satisfies Record<string, ReviewSource>

export const ReviewSourceValues: readonly ReviewSource[] = Object.values(ReviewSource)
